import React from 'react';
import AppRouter from './AppRouter';

function App() {
  return <AppRouter />;
}

export default App;
